// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_layout_layout_module_ts":"8dd56b50d6427e236458","src_app_reports_reports_module_ts":"e3175f7dbf4924e45792"}[chunkId] + ".js";
};